import { InvoiceLineType } from '@features/invoices/enums/invoiceLineType'
import { InvoiceFormDescriptionLine } from '@features/invoices/types/invoiceForm/invoiceFormLine/invoiceFormDescriptionLine'

export const getDefaultDescriptionLine = (): InvoiceFormDescriptionLine => ({
  content: '',
  type: InvoiceLineType.Description,
})
